/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function MediaAcceptProfilesVideoValidatorEditViewController(this: JS5Object, MediaAcceptProfileService: JS5Object,
                                                             uiGridConstants: JS5Object, $location: JS5Object,
                                                             NavbarUtilService: JS5Object, ModalService: JS5Object,
                                                             $routeParams: JS5Object, $route: JS5Object, $timeout: JS5Function,
                                                             BreadcrumbService: JS5Object) {


    this.validateInteger = (value: number) => {
        return _.isInteger(value) && _.toNumber(value) > -1;
    };

    const splitValidators = (validators: Array<JS5Object>) => {
        if ($routeParams.validatorId !== '-1') {
            this.editData = _.first(_.remove(validators, {id: $routeParams.validatorId}));
        }
        this.otherValidators = _.cloneDeep(validators);
    };

    this.dropframeOptions = [
        {
            name: 'Drop Frame',
            value: 'true'
        }, {
            name: 'Non-Drop Frame',
            value: 'false'
        }];

    const setValidator = (validators: Array<JS5Object>) => {
        splitValidators(validators);
        this.dropFrame = _.find(this.dropframeOptions, {
            value: this.editData.dropFrame
        });
        MediaAcceptProfileService.originalVideoValidatorEditData = _.cloneDeep(this.editData);
        this.originalTrackNumber = _.toNumber(this.editData.trackNumber);
        this.editData.trackNumber = !_.isNil(this.editData.trackNumber) ? _.toNumber(this.editData.trackNumber) : undefined;
    };

    const getData = () => {
        this.loadingIndicator.show = true;
        MediaAcceptProfileService.getValidators($routeParams.id).then((validators: Array<JS5Object>) => {
            setValidator(validators);
            if (_.get(this.editData, 'hidden') || _.isNil(this.editData)) {
                $location.url(`/system/templates/media/acceptProfiles/edit/${$routeParams.id}`).search({editView: 'video'})
            }
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const getExistingValidators = () => {
        MediaAcceptProfileService.getValidators($routeParams.id, false, {validatorType: 'VIDEO'}).then((existingVideoValidators: JS5Object) => {
            this.existingVideoValidatorTrackNumbers = [];
            _.forEachRight(existingVideoValidators, (videoValidator) => {
                this.existingVideoValidatorTrackNumbers.push(_.toNumber(_.get(videoValidator, 'trackNumber')));
            });
            this.existingVideoValidatorTrackNumbers.sort();
            this.existingVideoValidatorTrackNumberWarningMessage = {
                type: 'error',
                message: `This track number is already in use! Track numbers currently in use: ${this.existingVideoValidatorTrackNumbers.join(', ')}`
            };
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const trackNumberExists = (suppliedTrackNumber: any) => {
        return _.includes(this.existingVideoValidatorTrackNumbers, suppliedTrackNumber);
    };

    this.trackNumberNotAllowed = () => {
        return trackNumberExists(this.editData.trackNumber)
            && this.editData.trackNumber > -1
            && this.editorForm.$dirty
            && this.originalTrackNumber !== this.editData.trackNumber
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        this.editData.dropFrame = _.get(this, 'dropFrame.value');
        this.editData.validatorType = 'VIDEO';
        if (!_.size(_.get(this, 'editData.startTime'))) {
            _.unset(this, 'editData.startTime');
        }
        let validatorsToSave = _.concat([this.editData], this.otherValidators);
        MediaAcceptProfileService.updateValidators($routeParams.id, validatorsToSave).then((validators: Array<JS5Object>) => {
            const updatedValidator: JS5Object = _.find(validators, <JS5Object>{
                trackNumber: _.toString(this.editData.trackNumber),
                validatorType: 'VIDEO'
            });
            $route.updateParams({validatorId : updatedValidator.id});
            setValidator(validators);
        }).finally(() => {
            this.loadingIndicator.show = false;
            this.editorForm.$setPristine();
        });
    };


    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine')
                && !this.trackNumberNotAllowed()
                && !_.isNil(_.get(this.editData, 'trackNumber'))
                && _.toNumber(_.get(this.editData, 'trackNumber')) > -1
                && _.isInteger(_.toNumber(_.get(this.editData, 'trackNumber'))),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editorForm.$setPristine();
                if ($routeParams.validatorId !== '-1') {
                    this.originalTrackNumber = _.toNumber(MediaAcceptProfileService.originalVideoValidatorEditData.trackNumber);
                    this.editData = _.cloneDeep(MediaAcceptProfileService.originalVideoValidatorEditData);
                    this.editData.trackNumber = _.toNumber(MediaAcceptProfileService.originalVideoValidatorEditData.trackNumber);
                    this.dropFrame = this.editData.dropFrame === 'true';
                    this.editorForm.$setPristine();
                } else {
                    $location.url(`/system/templates/media/acceptProfiles/edit/${$routeParams.id}`).search({editView: 'video'})
                }
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/templates/media/acceptProfiles/edit/${$routeParams.id}`).search({editView: 'video'})
        }
    ];

    this.$onInit = () => {
        this.editData = {
            trackNumber: undefined
        };
        this.dropFrame = null;
        this.existingVideoValidatorTrackNumbers = [];

        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getExistingValidators();
        getData();

        if (!_.size(BreadcrumbService.getBreadcrumbs())) {
            BreadcrumbService.addBreadcrumb({
                name: 'Edit Media Accept Profile Template',
                location: `/system/templates/search`,
                params: {tab: 'Media', subTab: 'MediaAcceptProfiles'}
            });
            BreadcrumbService.addBreadcrumb({
                name: _.get(this, 'acceptProfile.name'),
                location: `/system/templates/media/acceptProfiles/edit/${_.get(this, 'acceptProfile.id')}`,
                params: {editView: 'video'}
            });
        }
    };

    this.$postLink = () => {
        $timeout(() => {
            MediaAcceptProfileService.editorForm = this.editorForm;
        });
    };

    this.$onDestroy = () => {
        MediaAcceptProfileService.editorForm = null;
    };
}


angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesVideoValidatorEditView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/video/editor/media-accept-profiles-video-validator-edit-view-template.html',
    controller: MediaAcceptProfilesVideoValidatorEditViewController,
    bindings: {
        acceptProfile: '<'
    }
});
